import React from 'react';
import './presentations.css';
import PresentationCard from '../presentationCard/presentationCard'
import Grid from '@material-ui/core/Grid';
import { getTalks } from '../../services/contentService';
class Presentations extends React.Component {
    constructor(props) {
      super(props);
      this.state = {projects:[],loading:true};
      // To use the 'this' keyword, we need to bind it to our function
    }
    async componentDidMount(){
        try {
            const projects = await getTalks();
            this.setState({projects,loading:false});
        } catch (_) {
            this.setState({projects:[], loading:false});
        }
    }

    handleSubmit(){

    }

    getloading(){
        return(
               <div className = 'loader-container'>
                 <div className = 'spinner'></div>
               </div>
        );
       }


       getGrid(){
        return(
            <Grid container className='gridList' alignItems="center"
   alignContent='space-between' spacing={0.5}>
            {this.state.projects.map(project=>(<Grid item key={project.slug} className='presentation-card-grid' xs={6} sm={4}  md={3} lg={2}><PresentationCard item={project}/></Grid>))}
            </Grid>
        )
       }

    render(){ 
        const response = this.state.loading?this.getloading():this.getGrid();
        return (
            <div className="presentation-card">
                <div className='title'>
                Talks
            </div>
            <div>
            {response}
        </div>
            </div>
        )
    }

}

export default Presentations;